import store from '/@/vuex'
export default (to, from, next) => {
  const newTo = {
    fullPath: to.fullPath,
    meta: to.meta,
    name: to.name,
    path: to.path,
    params: to.params,
    query: to.query
  }
  to.meta && to.meta.needLogin && !to.meta.noTag && store.dispatch('tag/setTag', newTo)
  next()
}
